import React from 'react';
import '../Styling/cards.css';
import '../Styling/days.css';
import ContactForm from '../Components/contactForm';


export default function Day3() {
    return (<>
    
    <div id="rootAlign">
<div className='dayDescription'>
Day 3 offers a personalized journey, merging the opulence of our Shopping Extravaganza with the rustic charm of Countryside Exploration. Revel in the allure of gems, jewelry, Miniature Paintings, Carpets, Textiles, Spices, Marble Sculptures, Wooden and Metal Artifacts, and the unique artistry of Block Printed Textiles. Embrace the tranquility of the countryside, visit the Elephant Village, experience a Leopard Safari, explore Galta Ji on a spiritual hike, and conclude with a luxurious retreat. Customize your adventure by reaching out via email or WhatsApp, allowing your day in Jaipur to be as unique as you are.
    </div>
    <div className="dayHeading day3Heading1"></div>

    <div className="daysContainer bgImgRight bgImg1">
      <div className='align'>

      <div className="dayDesc day3Desc1"></div>
      <div className="dayCard day3Card1"></div>
      </div>
    </div>


    <div className="daysContainer bgImgLeft bgImg2">
      <div className='align'>

      <div className="dayDesc day3Desc2"></div>
      <div className="dayCard day3Card2"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg3">
      <div className='align'>   

      <div className="dayDesc day3Desc3"></div>
      <div className="dayCard day3Card3"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg4">
      <div className='align'>

      <div className="dayDesc day3Desc4"></div>
      <div className="dayCard day3Card4"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg5">
      <div className='align'>

      <div className="dayDesc day3Desc5"></div>
      <div className="dayCard day3Card5"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg6">
      <div className='align'>

      <div className="dayDesc day3Desc6"></div>
      <div className="dayCard day3Card6"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg7">
      <div className='align'>

      <div className="dayDesc day3Desc7"></div>
      <div className="dayCard day3Card7"></div>
      </div>
    </div>



{/* *******************************************COUNTRYSIDE EXPLORATION******************************************* */}
    <div className="dayHeading day3Heading2"></div>

    <div className="daysContainer bgImgRight bgImg1">
      <div className='align'>

      <div className="dayDesc day3DescB1"></div>
      <div className="dayCard day3CardB1"></div>
      </div>
    </div>


    <div className="daysContainer bgImgLeft bgImg2">
      <div className='align'>

      <div className="dayDesc day3DescB2"></div>
      <div className="dayCard day3CardB2"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg3">
      <div className='align'>   

      <div className="dayDesc day3DescB3"></div>
      <div className="dayCard day3CardB3"></div>
      </div>
    </div>
    <div className="daysContainer bgImgLeft bgImg4">
      <div className='align'>

      <div className="dayDesc day3DescB4"></div>
      <div className="dayCard day3CardB4"></div>
      </div>
    </div>
    <div className="daysContainer bgImgRight bgImg5">
      <div className='align'>

      <div className="dayDesc day3DescB5"></div>
      <div className="dayCard day3CardB5"></div>
      </div>
    </div>

    </div>
<ContactForm/>

    </> );
};